import React from 'react';

function SkeletonCommunityCard() {
  return (
    <>
      <div className="card-row">
        <div className="box-col gap10 pd0">
          <div className="box-row pd0">
            <div className="group-align-left">
              <div className="skeleton-avatar skeleton-pulse" />
              <div className="skeleton-line skeleton-pulse skeleton-line-30 skeleton-line-sm" />
              <div className="skeleton-line skeleton-pulse skeleton-line-20 skeleton-line-sm" />
            </div>
          </div>
          <div className="skeleton-line skeleton-pulse skeleton-line-title skeleton-line-70" />
          <div className="skeleton-card-actions">
            <div className="skeleton-pill skeleton-pulse" />
            <div className="skeleton-pill skeleton-pulse" />
            <div className="skeleton-pill skeleton-pulse" />
          </div>
        </div>
      </div>
      <hr />
    </>
  );
}

export default SkeletonCommunityCard;
